import {
    Box, Breadcrumbs, Button, Modal, FormControl, InputLabel, Select, MenuItem,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link } from "react-router-dom";
import { PREDICTION_TYPE } from '../constant/constant';
import { ADD_CATEGORY_LOGO, GET_CATEGORY_LOGO, DELETE_CATEGORY_LOGO } from '../constant/endpoint';
import axios from "axios";
import Swal from "sweetalert2";


const CategoryLogo = () => {
    const [open, setOpen] = useState(false);
    const [categoryType, setCategoryType] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [previewURL, setPreviewURL] = useState(null);
    const [categories, setCategories] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);

    const handleOpen = () => {
        setOpen(true);
        setEditMode(false);
    };

    const handleClose = () => {
        setOpen(false);
        setCategoryType("");
        setImageFile(null);
        setPreviewURL(null);
        setEditMode(false);
        setEditId(null);
    };

    const fetchCategories = async () => {
        try {
            const { data } = await axios.get(GET_CATEGORY_LOGO);
            // console.log(data, "-------");

            const categoryArray = data?.data; // Extract nested array

            if (Array.isArray(categoryArray)) {
                setCategories(categoryArray);
            } else {
                setCategories([]); // fallback to empty array
            }
        } catch (err) {
            console.error("Failed to fetch categories", err);
            setCategories([]);
        }
    };


    useEffect(() => {
        fetchCategories();
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
        if (file) {
            setPreviewURL(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async () => {
        if (!categoryType || (!imageFile && !editMode)) {
            Swal.fire("Validation Error", "Both category type and image are required.", "warning");
            return;
        }

        if (!editMode && categories.some(cat => cat.type === categoryType)) {
            handleClose();
            Swal.fire("Duplicate", "This category type already exists.", "error");
            return;
        }

        // ❗️ In edit mode, if no new image is selected, prevent API call
        if (editMode && !imageFile) {
            handleClose();
            Swal.fire("Validation Error", "Please upload a new image to update.", "warning");
            return;
        }

        const formData = new FormData();
        formData.append("data", JSON.stringify({
            type: categoryType,
            status: true,
        }));
        if (imageFile) {
            formData.append("image", imageFile);
        }

        try {
            await axios.post(ADD_CATEGORY_LOGO, formData);
            Swal.fire("Success", editMode ? "Category updated successfully!" : "Category added successfully!", "success");
            handleClose();
            fetchCategories();
        } catch (error) {
            console.error("Error saving category:", error.response?.data || error.message);
            Swal.fire("Error", "Failed to save category.", "error");
        }
    };
    const handleDelete = async (type) => {
        const confirm = await Swal.fire({
            title: `Delete ${type}?`,
            text: "This will permanently remove the category logo.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (confirm.isConfirmed) {
            try {
                await axios.delete(`${DELETE_CATEGORY_LOGO}?type=${type}`);
                Swal.fire("Deleted!", "Category logo has been deleted.", "success");
                fetchCategories();
            } catch (err) {
                console.error("Delete failed", err);
                Swal.fire("Error", "Failed to delete category logo.", "error");
            }
        }
    };


    const handleEdit = (category) => {
        setEditMode(true);
        setEditId(category.id);
        setCategoryType(category.type);
        setPreviewURL(category.image_url); // Make sure `image` is the full URL
        setOpen(true);
    };

    return (
        <div className="homeCard">
            <div className="subHomeCard">
                <Breadcrumbs separator={<MdNavigateNext fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" key="1" color="inherit" to={""}>
                        <h4>Category</h4>
                    </Link>
                    <h5>List</h5>
                </Breadcrumbs>

                <Button
                    variant="contained"
                    color="primary"
                    style={{ float: "right" }}
                    onClick={handleOpen}
                >
                    Add Category Logo
                </Button>

                {/* Table */}
                <TableContainer component={Paper} sx={{ marginTop: 5 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><b> Match Category Name</b></TableCell>
                                <TableCell><b>Category Logo</b></TableCell>
                                <TableCell sx={{ width: '160px' }}><b>Actions</b></TableCell> {/* Limit width */}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {categories.map((cat) => (
                                <TableRow key={cat.id}>
                                    <TableCell>{cat.type}</TableCell>
                                    <TableCell>
                                        <img src={cat.image_url} alt="Category" width="80" />
                                    </TableCell>
                                    <TableCell sx={{ width: '160px' }}>
                                        <Box display="flex" gap={1} flexWrap="wrap">
                                            <Button
                                                onClick={() => handleEdit(cat)}
                                                variant="outlined"
                                                size="small" // ↓ Smaller button
                                            >
                                                Edit
                                            </Button>
                                            <Button
                                                onClick={() => handleDelete(cat.type)}
                                                variant="outlined"
                                                color="error"
                                                size="small"
                                            >
                                                Delete
                                            </Button>
                                        </Box>
                                    </TableCell>


                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Modal */}
                <Modal open={open} onClose={handleClose}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="category-label">Category Type</InputLabel>
                            <Select
                                labelId="category-label"
                                value={categoryType}
                                onChange={(e) => setCategoryType(e.target.value)}
                                label="Category Type"
                                disabled={editMode}
                            >
                                {["OVERS", "WICKETS"].map((type) => (
                                    <MenuItem key={type} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />

                        {/* Image Preview */}
                        {previewURL && (
                            <Box sx={{ mt: 2, textAlign: "center" }}>
                                <img
                                    src={previewURL}
                                    alt="Preview"
                                    style={{ maxWidth: "100%", maxHeight: 200 }}
                                />
                            </Box>
                        )}

                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            {editMode ? "Update" : "Submit"}
                        </Button>
                    </Box>
                </Modal>
            </div>
        </div>
    );
};

export default CategoryLogo;